/** The raw materials a quote can follow: those with a published benchmark. */
export const MATERIAL_CODES = ['PP', 'PE', 'PET'];
export const materialLabels = {
    PP: 'PP 聚丙烯',
    PE: 'PE 聚乙烯',
    PET: 'PET 瓶片',
};
/** The benchmark each material follows: the main futures contract's daily settlement price. */
export const benchmarkNames = {
    PP: '大商所聚丙烯',
    PE: '大商所聚乙烯',
    PET: '郑商所瓶片',
};
/** A signed percentage to 0.1%, e.g. 0.027 -> "+2.7%", -0.013 -> "-1.3%". */
export function signedPercent(rate) {
    const n = Math.round(Number(rate) * 1000) / 10;
    return `${n > 0 ? '+' : ''}${n.toFixed(1)}%`;
}
const grouped = (v) => Number(v).toLocaleString('zh-CN');
const monthDay = (v) => `${Number(v.slice(5, 7))}/${Number(v.slice(8, 10))}`;
/**
 * One sentence per distinct basis, e.g. "PP：大商所聚丙烯结算价 9,897（10/26）→ 10,299（10/29），
 * +4.1% × 原料占成本 65% = +2.7%". Lines quoted on the same day share one sentence.
 */
export function adjustReasons(adjusts) {
    const seen = new Map();
    for (const a of adjusts) {
        if (!a)
            continue;
        const key = [a.material, a.base, a.baseDate, a.price, a.priceDate, a.share].join('|');
        if (seen.has(key))
            continue;
        seen.set(key, `${a.material}：${benchmarkNames[a.material]}结算价 ${grouped(a.base)}（${monthDay(a.baseDate)}）→ ` +
            `${grouped(a.price)}（${monthDay(a.priceDate)}），${signedPercent(a.change)} × 原料占成本 ` +
            `${Math.round(Number(a.share) * 100)}% = ${signedPercent(a.rate)}`);
    }
    return [...seen.values()];
}
/**
 * The order-level figure: adjustment amount over goods amount, e.g. "+2.7%". Lines at different
 * rates (several materials, or a line priced by hand) blend into one weighted percentage.
 */
export function blendedRate(goods, adjustment) {
    return goods ? signedPercent(adjustment / goods) : '';
}
/** Reads the material from an item's name or spec, e.g. "28口白色PP防盗盖" is PP. */
export function detectMaterial(text) {
    const t = text.toUpperCase();
    if (/PET|瓶片|聚酯/.test(t))
        return 'PET';
    // Whole tokens only, so letters inside other words (OPEN, SPEC) do not count.
    if (/(^|[^A-Z])PP([^A-Z]|$)|聚丙烯/.test(t))
        return 'PP';
    if (/(^|[^A-Z])(HD|LD|LLD)?PE([^A-Z]|$)|聚乙烯/.test(t))
        return 'PE';
    return null;
}
